import gql from "graphql-tag";

import { Fragment, Document } from "../types";

export const DOCUMENT_FRAGMENT = gql`
  fragment DocumentFragment on Document {
    filename
    id
    url
  }
`;

export type DocumentFragment = Fragment<Document, Document>;
